module.exports = __webpack_public_path__ + "img/percocet.53889d47.png";